import styled from 'styled-components';

const ErrorContainer = styled.section`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  padding: 5rem 0;

  .error-content {
    color: #525252;
    font-weight: bold;
    text-align: center;
  }

  .error-status {
    font-size: 10rem;
    line-height: 10rem;
  }

  .error-title {
    font-size: 2rem;
    margin-bottom: 1rem;
  }

  .error-message {
    color: #9f9f9f;
    font-weight: normal;
  }
`;

export default ErrorContainer;
